KXL.module('Entities', function(Entities, KXL, Backbone, Marionette, $, _) {
    Entities.UserFlags = Entities.Model.extend({
		idAttribute: 'userId',
        url: function () {
            return KXL.config.API_URL + '/users/' + KXL.currentUser.id + '/flags';
        }
    });

	var API = {
		getUserFlags: function (userId) {
			var deferred = $.Deferred();
			var userFlags = new KXL.Entities.UserFlags({userId: userId});
			userFlags.fetch({
				success: function (entity, response, options) {
					deferred.resolve(entity, response, options);
				},
				error: function (entity, response, options) {
					deferred.reject(entity, response, options);
				}
			});
			deferred._model = userFlags;
			return deferred;
		}
	};

	KXL.reqres.setHandler('user:flags:entity', function (userId) {
		return API.getUserFlags(userId);
	});
});
